import { render } from "./JuryInstructions.vue?vue&type=template&id=d748e7b6&scoped=true"
import script from "./JuryInstructions.vue?vue&type=script&lang=js"
export * from "./JuryInstructions.vue?vue&type=script&lang=js"

import "./JuryInstructions.vue?vue&type=style&index=0&id=d748e7b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d748e7b6"]])

export default __exports__